import { userMarketplaceApi, } from '@sellsen/generated-sources';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
const QUERY_KEYS = {
    all: ['user-marketplace'],
    getAvailable: () => [...QUERY_KEYS.all, 'available'],
    getActive: () => [...QUERY_KEYS.all, 'active'],
};
export const useGetAvailableMarketplaces = () => {
    return useQuery({
        queryKey: QUERY_KEYS.getAvailable(),
        queryFn: () => {
            return userMarketplaceApi.getAvailable();
        },
    });
};
export const useGetUsersMarketplaces = () => {
    return useQuery({
        queryKey: QUERY_KEYS.getActive(),
        queryFn: () => {
            return userMarketplaceApi.getActive();
        },
    });
};
export const useUserMarketPlaceMutation = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (params) => userMarketplaceApi.addActive(params),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: QUERY_KEYS.all,
            });
        },
    });
};
